import { render } from "./MyInput.vue?vue&type=template&id=c8df63ca"
import script from "./MyInput.vue?vue&type=script&lang=js"
export * from "./MyInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__